import { useEffect, useState } from 'react';

export default function Loader() {
  const [width, setWidth] = useState(0);

  useEffect(() => {
    // Start sliding immediately
    const t1 = setTimeout(() => setWidth(30), 50);
    const t2 = setTimeout(() => setWidth(60), 300);
    const t3 = setTimeout(() => setWidth(85), 700);
    return () => {
      clearTimeout(t1);
      clearTimeout(t2);
      clearTimeout(t3);
    };
  }, []);

  return (
    <div className="fixed top-0 left-0 z-[2001] w-full h-[3px] bg-transparent">
      <div
        className="h-full rounded-r-sm"
        style={{
          width: `${width}%`,
          background: 'linear-gradient(90deg, #1677ff, #69b1ff)',
          boxShadow: '0 0 8px #1677ff88',
          transition: 'width 0.4s cubic-bezier(0.4, 0, 0.2, 1)'
        }}
      />
    </div>
  );
}
